import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["id", "itemText", "onClick", "icon"],
    _excluded2 = ["id", "onClick", "shouldHideMenuItem", "shouldDisableMenuItem", "disabled"];

/*
 * Licensed Materials - Property of IBM
 * 5724-Q36
 * (c) Copyright IBM Corp. 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import React from 'react';
import cx from 'classnames';
import { IconSkeleton, OverflowMenu, OverflowMenuItem } from 'carbon-components-react';
import { pkg } from '../../settings';
var blockClass = "".concat(pkg.prefix, "--datagrid");

var useActionsColumn = function useActionsColumn(hooks) {
  var useAttachActionsOnInstance = function useAttachActionsOnInstance(instance) {
    var rowActions = instance.rowActions,
        isFetching = instance.isFetching,
        selectedFlatRows = instance.selectedFlatRows;

    if (rowActions && Array.isArray(rowActions)) {
      var addActionsMenu = function addActionsMenu(props, cellData) {
        var cell = cellData.cell;
        var row = cell.row,
            column = cell.column;

        if (column.isAction) {
          var _cx3;

          return [props, {
            children: /*#__PURE__*/React.createElement("div", {
              className: "".concat(blockClass, "__actions-column-contents")
            }, isFetching && /*#__PURE__*/React.createElement(IconSkeleton, {
              className: "".concat(blockClass, "__actions-column-loading")
            }), !isFetching && rowActions.length <= 2 && /*#__PURE__*/React.createElement("div", {
              className: "".concat(blockClass, "_actions-column"),
              style: {
                display: 'flex'
              }
            }, rowActions.map(function (action, index) {
              var id = action.id,
                  itemText = action.itemText,
                  _onClick = action.onClick,
                  icon = action.icon,
                  rest = _objectWithoutProperties(action, _excluded);

              var selectedRowId = selectedFlatRows === null || selectedFlatRows === void 0 ? void 0 : selectedFlatRows.filter(function (item) {
                return item.id === row.id ? item.id : null;
              });
              return /*#__PURE__*/React.createElement("div", {
                className: cx("".concat(blockClass, "__actions-column-button"), _defineProperty({}, "".concat(blockClass, "__disabled-row-action-button"), selectedFlatRows && selectedFlatRows.length && selectedRowId && selectedRowId.length)),
                key: "".concat(itemText, "__").concat(index)
              }, /*#__PURE__*/React.createElement(OverflowMenu, _extends({}, rest, {
                renderIcon: icon,
                hasIconOnly: true,
                light: true,
                iconDescription: itemText,
                kind: "ghost",
                className: cx(_defineProperty({}, "".concat(blockClass, "__disabled-row-action"), selectedFlatRows && selectedFlatRows.length && selectedRowId && selectedRowId.length)),
                onClick: function onClick(e) {
                  if (selectedFlatRows && selectedFlatRows.length && selectedRowId && selectedRowId.length) {
                    // Row actions should be disabled if row is selected and batchActions toolbar is active
                    return;
                  }

                  e.stopPropagation();

                  _onClick(id, row, e);
                }
              })));
            })), !isFetching && rowActions.length > 2 && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(OverflowMenu, {
              size: "sm",
              light: true,
              flipped: true,
              onClick: function onClick(e) {
                e.stopPropagation();
              }
            }, rowActions.map(function (action) {
              var id = action.id,
                  _onClick2 = action.onClick,
                  shouldHideMenuItem = action.shouldHideMenuItem,
                  shouldDisableMenuItem = action.shouldDisableMenuItem,
                  disabled = action.disabled,
                  rest = _objectWithoutProperties(action, _excluded2);

              var hidden = typeof shouldHideMenuItem === 'function' && shouldHideMenuItem(row); // shouldDisableMenuItem will override disabled because it's more specific
              // if shouldDisableMenuItem doesn't exists, fall back to disabled

              var isDisabledByRow = typeof shouldDisableMenuItem === 'function' ? shouldDisableMenuItem(row) : disabled;

              if (hidden) {
                return null;
              }

              return /*#__PURE__*/React.createElement(OverflowMenuItem, _extends({}, rest, {
                disabled: isDisabledByRow,
                onClick: function onClick(e) {
                  e.stopPropagation();

                  _onClick2(id, row, e);
                },
                key: id
              }));
            })))),
            className: cx((_cx3 = {}, _defineProperty(_cx3, "".concat(blockClass, "__actions-column-cell"), true), _defineProperty(_cx3, "".concat(blockClass, "__cell"), true), _cx3)),
            style: {
              width: 96
            }
          }];
        }

        return [props];
      };

      hooks.getCellProps.push(addActionsMenu);
    }
  };

  hooks.useInstance.push(useAttachActionsOnInstance);
};

export default useActionsColumn;